import { render } from "./CoreCompetency.vue?vue&type=template&id=72a3f5f0&scoped=true"
import script from "./CoreCompetency.vue?vue&type=script&lang=js"
export * from "./CoreCompetency.vue?vue&type=script&lang=js"

import "./CoreCompetency.vue?vue&type=style&index=0&id=72a3f5f0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72a3f5f0"]])

export default __exports__